import React from 'react';

const Footer = ({ user, onLoginClick, onLogoutClick }) => {
  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div>
          🍿
        </div>
        <div>
          <button
            onClick={user ? onLogoutClick : onLoginClick}
            className="hover:text-pink-400 transition-colors font-semibold"
            style={{fontFamily: 'Space Grotesk, sans-serif'}}
          >
            {user ? 'Logout' : 'Login'}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;